import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TabsHeader = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
`;

interface BtnTabProps {
  isActive?: boolean;
}

export const BtnTab = styled.button<BtnTabProps>`
  position: relative;
  background: none;
  border: none;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: ${({ isActive }) => (isActive ? "600" : "400")};
  color: ${({ isActive }) => (isActive ? "#111" : "#666")};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #111;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: ${({ isActive }) => (isActive ? "#111" : "transparent")};
    transition: background-color 0.2s;
    border-radius: 2px;
  }

  @media (max-width: 500px) {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
`;

export const BodyTab = styled.main`
  background-color: #fff;
  border-radius: 0.5rem;
  padding: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
